import { FC } from "react";
import { Box, Typography, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import moment from "moment";

interface MonthSelectProps {
  month: number;
  year: number;
  onNext: () => void;
  onPrev: () => void;
  disabled?: boolean;
  hasMonthName?: boolean;
}

export const MonthSelect: FC<MonthSelectProps> = ({ month, year, onNext, onPrev, disabled, hasMonthName }) => {
  const classes = useStyles();
  
  return (
    <Box data-testid="testMonthSelect" className={classes.dateBox}>
      <IconButton
        data-testid="testMonthSelectButton"
        onClick={onPrev}
        className={classes.iconButton}
      >
        <NavigateBeforeIcon />
      </IconButton>
      <Typography variant="body2" className={classes.date}>
        {hasMonthName ? `(${moment.months(month-1).slice(0,3)})` : ""} {month}.{year}
      </Typography>
      <IconButton
        data-testid="testMonthSelectButtonTwo"
        onClick={onNext}
        className={classes.iconButton}
        disabled={disabled}
      >
        <NavigateNextIcon />
      </IconButton>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  date: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    display: "flex",
    flexDirection: "row",
  },
  dateBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  iconButton: {
    padding: "0",
    margin: "0 10px",
    color: theme.palette.primary.main,
  },
}));
